<template>
  <icon-font :type="type" />
</template>

<script>
import { Icon } from "ant-design-vue";
import icon from './icon.js';

const IconFont = Icon.createFromIconfontCN({
  // scriptUrl: "//at.alicdn.com/t/font_1611480_i97ffx3e1tq.js"
  scriptUrl: icon,
});

export default {
  props: {
    type: String,
  },
  components: {
    IconFont,
  },
};
</script>

<style></style>
